import request from '@/shared/apis'


// URL helper functions
const getBaseApiUrl = (templateId) => {
  return `/evaluations/templates/${templateId}/sections`;
};

const getSectionApiUrl = (templateId, sectionId) => {
  return `${getBaseApiUrl(templateId)}/${sectionId}`;
};

export const getSectionsApi = async (templateId, evaluationId) => {
  return await request.get(getBaseApiUrl(templateId).concat( !evaluationId ? "" : `?evaluation=${evaluationId}`));
};

export const getSectionByIdApi = async (templateId, sectionId) => {
  return await request.get(getSectionApiUrl(templateId, sectionId));
};

export const createSectionApi = async (templateId, data) => {
  return await request.post(getBaseApiUrl(templateId), data);
};

export const updateSectionApi = async (templateId, sectionId, data) => {
  return await request.put(getSectionApiUrl(templateId, sectionId), data);
};

export const deleteSectionApi = async (templateId, sectionId) => {
  return await request.delete(getSectionApiUrl(templateId, sectionId));
};
